(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-page-style"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Headings: keep "6 days" on one line; wrap "+" and "₂" so they can be styled */
    var MARKS = { '+': 'heading-plus', '₂': 'heading-sub2' };
    function headings() {
      document.querySelectorAll('#MainContent h2, #MainContent p.rich-text__heading').forEach(function (h) {
        var walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), nodes = [];
        while (walker.nextNode()) nodes.push(walker.currentNode);
        nodes.forEach(function (n) {
          n.nodeValue = n.nodeValue.replace(/(\d)\s+(days?\b)/gi, '$1 $2');
          var parent = n.parentNode;
          if (parent.classList && (parent.classList.contains('heading-plus') || parent.classList.contains('heading-sub2'))) return;
          if (!/[+₂]/.test(n.nodeValue)) return;
          var frag = document.createDocumentFragment();
          n.nodeValue.split(/([+₂])/).forEach(function (part) {
            if (!part) return;
            if (MARKS[part]) {
              var span = document.createElement('span');
              span.className = MARKS[part];
              span.textContent = part;
              frag.appendChild(span);
            } else {
              frag.appendChild(document.createTextNode(part));
            }
          });
          parent.replaceChild(frag, n);
        });
      });
    }

    /* Sticky add-to-cart bar: short variant labels on mobile, e.g. "2 boxes · $119" */
    function stickyLabels() {
      var data = document.querySelector('[data-custom-page-style-sticky-labels]');
      if (!data) return;
      var labels = JSON.parse(data.textContent);
      var mq = window.matchMedia('(max-width: 749px)');
      function apply() {
        document.querySelectorAll('.sticky-atc-bar__variant-select option').forEach(function (o) {
          if (!o.dataset.full) o.dataset.full = o.textContent.trim();
          o.textContent = mq.matches && labels[o.value] ? labels[o.value] : o.dataset.full;
        });
      }
      function watch(container) {
        /* Re-apply when the sticky bar re-renders (e.g. after a variant change) */
        new MutationObserver(function () {
          if (container.querySelector('.sticky-atc-bar__variant-select option:not([data-full])')) apply();
        }).observe(container, { childList: true, subtree: true });
      }
      function whenReady() {
        var select = document.querySelector('.sticky-atc-bar__variant-select');
        if (select) { apply(); watch(select.closest('.shopify-section') || select.parentNode); return; }
        var obs = new MutationObserver(function () {
          var found = document.querySelector('.sticky-atc-bar__variant-select');
          if (found) { obs.disconnect(); apply(); watch(found.closest('.shopify-section') || found.parentNode); }
        });
        obs.observe(document.body, { childList: true, subtree: true });
      }
      whenReady();
      if (mq.addEventListener) mq.addEventListener('change', apply);
    }

    function init() { headings(); stickyLabels(); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', headings);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.customStepsReady) return;
      var track = root.querySelector('[data-custom-steps-track]');
      var prev = root.querySelector('[data-custom-steps-prev]');
      var next = root.querySelector('[data-custom-steps-next]');
      if (!track || !prev || !next) return;
      root.dataset.customStepsReady = 'true';
      function step() {
        var col = track.querySelector('.custom-steps__col');
        var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
        return col ? col.getBoundingClientRect().width + gap : track.clientWidth;
      }
      function update() {
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    }
    function initAll() { document.querySelectorAll('[data-custom-steps]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();
})();
